module.exports = __webpack_public_path__ + "img/10Life_logo-txt_black-bg_transparent.43ea159.png";